import React from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * 權限包裝組件
 * @param {Object} props
 * @param {React.ReactNode} props.children - 要包裝的子組件
 * @param {boolean} props.requireWrite - 是否需要寫入權限，預設為 false
 * @param {React.ReactNode} props.fallback - 無權限時顯示的內容，預設為 null
 * @param {boolean} props.disabled - 是否禁用子組件（僅適用於表單元素）
 * @param {string} props.observerText - 觀察者顯示的文字
 */
const PermissionWrapper = ({
  children,
  requireWrite = false,
  fallback = null,
  disabled = false,
  observerText = '僅供查看'
}) => {
  const { user } = useAuth();

  const isObserver = () => user?.role === 'observer';
  const canWrite = () => user?.role !== 'observer';

  // 如果需要寫入權限但用戶是觀察者
  if (requireWrite && isObserver()) {
    return fallback;
  }

  // 如果設置了 disabled 且用戶是觀察者，則禁用元件
  if (disabled && isObserver()) {
    return React.cloneElement(children, {
      disabled: true,
      children: observerText
    });
  }

  return children;
};

export default PermissionWrapper;